const BASE_URL = "/api";

async function request(path, options = {}) {
  const res = await fetch(`${BASE_URL}${path}`, {
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      ...(options.headers || {}),
    },
    ...options,
  });

  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(text || `HTTP ${res.status}`);
  }

  const ct = res.headers.get("content-type") || "";
  if (ct.includes("application/json")) return res.json();
  return res.text();
}

export const personnelApi = {
  // ✅ Employees
  listEmployees: () => request(`/employees`),
  createEmployee: (dto) =>
    request(`/employees`, { method: "POST", body: JSON.stringify(dto) }),
  updateEmployee: (id, dto) =>
    request(`/employees/${id}`, { method: "PATCH", body: JSON.stringify(dto) }),
  deleteEmployee: (id) =>
    request(`/employees/${id}`, { method: "DELETE" }),
  deleteAllEmployees: () =>
    request(`/employees`, { method: "DELETE" }),
  importEmployees: (text) =>
    request(`/employees/import`, {
      method: "POST",
      body: JSON.stringify({ text }),
    }),

  // Contratti
  createContract: (employeeId, dto) =>
    request(`/personnel/employees/${employeeId}/contracts`, {
      method: "POST",
      body: JSON.stringify(dto),
    }),
  listContracts: (employeeId) =>
    request(`/personnel/employees/${employeeId}/contracts`),
  updateContract: (contractId, dto) =>
    request(`/personnel/contracts/${contractId}`, {
      method: "PATCH",
      body: JSON.stringify(dto),
    }),

  // Ferie
  getLeave: (employeeId) => request(`/personnel/employees/${employeeId}/leave`),
  upsertLeave: (employeeId, dto) =>
    request(`/personnel/employees/${employeeId}/leave`, {
      method: "POST",
      body: JSON.stringify(dto),
    }),

  // Paghe
  createPayroll: (employeeId, dto) =>
    request(`/personnel/employees/${employeeId}/payrolls`, {
      method: "POST",
      body: JSON.stringify(dto),
    }),
  listPayrolls: (employeeId, year) => {
    const q = year ? `?year=${encodeURIComponent(year)}` : "";
    return request(`/personnel/employees/${employeeId}/payrolls${q}`);
  },
  updatePayroll: (payrollId, dto) =>
    request(`/personnel/payrolls/${payrollId}`, {
      method: "PATCH",
      body: JSON.stringify(dto),
    }),

  // Extra
  createExtra: (payrollId, dto) =>
    request(`/personnel/payrolls/${payrollId}/extras`, {
      method: "POST",
      body: JSON.stringify(dto),
    }),
  listExtras: (payrollId) => request(`/personnel/payrolls/${payrollId}/extras`),

  // Cedolino
  upsertPayslip: (payrollId, dto) =>
    request(`/personnel/payrolls/${payrollId}/payslip`, {
      method: "POST",
      body: JSON.stringify(dto),
    }),
  sendPayslip: (payrollId, dto) =>
    request(`/personnel/payrolls/${payrollId}/payslip/send`, {
      method: "POST",
      body: JSON.stringify(dto),
    }),

  // Contratti in scadenza
  expiringContracts: (days = 30) =>
    request(`/personnel/contracts/expiring?days=${encodeURIComponent(days)}`),
};